import { render, staticRenderFns } from "./SettingsRotation.vue?vue&type=template&id=4e1d77ff&scoped=true&"
import script from "./SettingsRotation.vue?vue&type=script&lang=js&"
export * from "./SettingsRotation.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRotation.vue?vue&type=style&index=0&id=4e1d77ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d77ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1d77ff')) {
      api.createRecord('4e1d77ff', component.options)
    } else {
      api.reload('4e1d77ff', component.options)
    }
    module.hot.accept("./SettingsRotation.vue?vue&type=template&id=4e1d77ff&scoped=true&", function () {
      api.rerender('4e1d77ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsRotation.vue"
export default component.exports